
import "./styles.css";

const XCard = (props) => {
    return(
        <div className="x-Card" style={{ marginBottom:'30px', backgroundColor:props.color, border:`0.30px solid ${props.border}`}}>
            <img src={props.image} alt="sp"/>
            <div style ={{margin: '', fontWeight:600, fontSize:'16px'}}>{props.name}</div>
            <div class="numberCircle">{props.num}</div>
        </div>
    )
}

export default XCard